import { FormInstanceHistory } from './form-instance-history.model';

export class FormInstanceHistoryGridData {
    public data: FormInstanceHistory[];
    public total: number;
}
